module.exports = __webpack_public_path__ + "img/bg_s_4.2193dea2.png";